import React from 'react';
import { node, oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  children: node.isRequired,
  size: oneOf(['xl', 'lg', 'md', 'sm', 'xs', 'xxs']),
  variant: oneOf(['primary', 'secondary', 'accent']),
};

const defaultProps = {
  size: 'md',
  variant: 'primary',
};

const Diamond = ({ children, size, variant }) => {
  const className = cx('ui-diamond', `ui-diamond--${size}`, `bg-${variant}`);

  return (
    <div className={className}>
      <div className="ui-diamond__container">{children}</div>
    </div>
  );
};

Diamond.propTypes = propTypes;
Diamond.defaultProps = defaultProps;

export default Diamond;
